import { Dialog, DialogContent, DialogTitle, IconButton } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'

import './style.css'

import { FormBuy } from './FormBuy'

export const DialogFormBuy = ({ title, open, setOpen, initialState, handleOpenExtendedMode, loadIniBudget }) => {

    console.log('DialogFormBuy initialState----', initialState)

    return (
        <Dialog
            open={open}
            onClose={() => setOpen(false)}
            aria-labelledby="simple-dialog-title"
        >

            <DialogTitle>
                {title}
                <IconButton className='p-dialog-icon-close' aria-label="close" onClick={() => setOpen(false)}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>

            <DialogContent dividers className='DialogContentVistaPrevia'>
                <FormBuy
                    initialState={initialState}
                    setOpen={setOpen}
                    handleOpenExtendedMode={handleOpenExtendedMode}
                    loadIniBudget={loadIniBudget}
                />
            </DialogContent>

        </Dialog>
    )
}
